// src/services/api.js
import axios from 'axios';

// Create a configured instance of axios
const api = axios.create({
    baseURL: '/api', // This will be proxied to your server in development
    withCredentials: true, // This is crucial for sending cookies
});

// --- AUTHENTICATION FUNCTIONS ---

/**
 * Sends login credentials to the server.
 * @param {object} credentials - { username, password }
 * @returns {Promise} Axios promise
 */
export const login = (credentials) => {
    return api.post('/auth/login', credentials);
};

/**
 * Sends a request to log the user out.
 * @returns {Promise} Axios promise
 */
export const logout = () => {
    return api.post('/auth/logout');
};

/**
 * Sends a request to check the current user's session.
 * This now correctly calls the '/auth/user' endpoint defined in your server.
 * @returns {Promise} Axios promise
 */
export const checkAuth = () => {
    return api.get('/auth/user');
};


// --- MEETING FUNCTIONS ---

/**
 * Fetches the details for a specific meeting.
 * @param {string} meet_id - The public ID of the meeting.
 * @returns {Promise} Axios promise
 */
export const getMeetingById = (meet_id) => {
    return api.get(`/meetings/${meet_id}`);
};

// The default export is the configured axios instance.
export default api;
